//src/app/features/dashboard/admin/stats/TaxReturnRevenue.tsx
import Spinner from 'Components/Spinner';
import PieChartStats from './PieChartStats';
import { useGetTaxReturnRevenueQuery } from 'app/services/payments/orders';

const COLORS = ['#87cefa', '#4682b4'];

interface IEngagementLettersStats {
  year: number;
}

const TaxReturnRevenue = ({ year }: IEngagementLettersStats) => {
  const { data } = useGetTaxReturnRevenueQuery({
    filters: {
      year,
    },
  });

  if (!data)
    return (
      <div className="h-48 flex justify-center items-center">
        <Spinner />
      </div>
    );

  const {
    business_tax_returns_fees: individualFeeCents,
    individual_tax_returns_fees: businessFeeCents,
  } = data.tax_returns_fees;

  // Convert cents to dollars and round to whole number
  const businessFees = Math.round(businessFeeCents / 100);
  const indivualFees = Math.round(individualFeeCents / 100);

  const total = businessFees + indivualFees;
  return (
    <div className="flex-1">
      <div className="w-full flex-1 font-semibold px-4 pt-4 text-sm text-gray-dark">
        Tax Return Revenue
      </div>

      <PieChartStats
        data={[
          {
            name: 'Business',
            value: businessFees,
            label: <>${businessFees}</>,
          },
          {
            name: 'Individual',
            value: indivualFees,
            label: <>${indivualFees}</>,
          },
        ]}
        total={total}
        colors={COLORS}
        showPercentage={false}
      />
    </div>
  );
};

export default TaxReturnRevenue;
